import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SyncRegular from './sync-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SyncRegular {...validProps} />;
}
SvgComponent.iconName = 'sync-regular';

export const SyncRegularIcon = svgIconWrapper(SvgComponent);
